module.exports = __webpack_public_path__ + "img/AngelaMitchell.aa6f3060.png";